import { Image, ImageProps } from "@chakra-ui/react";
import { useState } from "react";

const ImageWithFallback = ({
  src,
  defaultSrc,
  ...rest
}: { src: string; defaultSrc: string } & ImageProps) => {
  const [hasFailed, setHasFailed] = useState(false);

  return (
    <Image
      src={hasFailed ? defaultSrc : src}
      onError={() => setHasFailed(true)}
      {...rest}
    />
  );
};

export const ImageWDefault = (
  props: {
    src: string;
    defaultSrc: string;
  } & ImageProps,
) => <ImageWithFallback key={props.src} {...props} />;
